import Alert from 'react-bootstrap/Alert';
function ErrorAlert(props) {

    if (props.show) {
        return (
          <Alert variant="danger">
            <Alert.Heading>{props.msg}</Alert.Heading>      
          </Alert>
        );
      } else {
        return (<></>);
      }
};

export default ErrorAlert;